export default __webpack_public_path__ + "static/media/single-04-office-active.3782378a.webp";